import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { Link } from '../../components'
import { ResourcesCardProps } from '../../types'
import { classNames } from '../../utils'
import { resourcesStyles } from './resourcesStyles'

export const ResourceCard = ({
  category,
  date,
  featured = false,
  imageAlt,
  imageFile,
  loadLazy = true,
  linkTo,
  overlayCategory = false,
  title,
}: ResourcesCardProps) => {
  return (
    <div
      className={classNames(
        featured ? 'col-span-12 md:col-span-5' : 'col-span-12 md:col-span-4'
      )}
    >
      <Link inline={false} to={linkTo}>
        <div className="relative overflow-clip">
          <GatsbyImage
            className={classNames(resourcesStyles.cardImage.base)}
            image={imageFile}
            alt={imageAlt}
            loading={loadLazy ? 'lazy' : 'eager'}
          />
          {overlayCategory && (
            <div className={resourcesStyles.cardOverlay.base}>
              <h3 className={resourcesStyles.cardOverlay.text}>{category}</h3>
            </div>
          )}
        </div>
      </Link>
      <h3 className={resourcesStyles.cardCategory.base}>
        {featured && (
          <span className={resourcesStyles.cardPill.base}>Featured</span>
        )}
        {category}
      </h3>
      <Link inline={false} to={linkTo}>
        <h2 className={resourcesStyles.cardTitle.base}>{title}</h2>
      </Link>
      <h4 className={resourcesStyles.cardDate.base}>{date}</h4>
    </div>
  )
}
